import { useEffect, useState } from "react";
import client from "@/lib/api";
import { MultiSelect } from "@/components/form/MultiSelect";
import { cn } from "@/lib/utils";

export const TOURS_STATUSES = ["New", "Preparing", "Scheduled", "Cancelled"];

export function CampaignKindToggle({ value, onChange }) {
  return (
    <div className="inline-flex rounded-lg border border-slate-200 bg-white p-0.5" data-testid="cmp-kind-toggle">
      {[[false, "Property Campaign"], [true, "Tours/DTR Campaign"]].map(([v, l]) => (
        <button key={l} type="button" onClick={() => onChange(v)} data-testid={`cmp-kind-${v ? "tours" : "property"}`}
          className={cn("rounded-md px-3 py-1.5 text-sm font-medium transition-colors", !!value === v ? "bg-sky-50 text-sky-700" : "text-slate-500 hover:text-slate-800")}>{l}</button>
      ))}
    </div>
  );
}

export function RegionPropertyPicker({ groupIds = [], propertyIds = [], onChange, orgs }) {
  const [groups, setGroups] = useState([]);
  useEffect(() => { client.get("/property-groups").then(({ data }) => setGroups(data)).catch(() => setGroups([])); }, []);
  const nameOf = (id) => orgs.find((o) => o.id === id)?.name;
  const selected = groups.filter((g) => groupIds.includes(g.id));
  const setGroups_ = (ids) => {
    const allowed = new Set(groups.filter((g) => ids.includes(g.id)).flatMap((g) => g.property_ids || []));
    onChange({ group_ids: ids, property_ids: propertyIds.filter((p) => allowed.has(p)) });
  };
  const toggle = (pid) => onChange({ group_ids: groupIds, property_ids: propertyIds.includes(pid) ? propertyIds.filter((p) => p !== pid) : [...propertyIds, pid] });
  const setRegionAll = (g, on) => {
    const ids = (g.property_ids || []).filter(nameOf);
    onChange({ group_ids: groupIds, property_ids: on ? [...new Set([...propertyIds, ...ids])] : propertyIds.filter((p) => !ids.includes(p)) });
  };
  return (
    <div className="space-y-2" data-testid="cmp-tours-regions">
      <div>
        <label className="mb-1.5 block text-xs font-semibold text-slate-600">Regions</label>
        <MultiSelect value={groupIds} onChange={setGroups_} options={groups.map((g) => ({ value: g.id, label: g.name }))} testid="cmp-field-regions" placeholder="Choose regions…" />
      </div>
      {selected.map((g) => {
        const props = (g.property_ids || []).filter(nameOf).sort((a, b) => nameOf(a).localeCompare(nameOf(b)));
        const allOn = props.length > 0 && props.every((p) => propertyIds.includes(p));
        return (
          <div key={g.id} className="rounded-lg border border-slate-200 p-3" data-testid={`cmp-region-${g.id}`}>
            <div className="mb-2 flex items-center justify-between">
              <p className="text-xs font-bold uppercase tracking-wide text-slate-500">{g.name} <span className="font-medium normal-case text-slate-400">· guest lists sent to</span></p>
              {props.length > 0 && <button type="button" onClick={() => setRegionAll(g, !allOn)} data-testid={`cmp-region-all-${g.id}`} className="text-xs font-semibold text-sky-600 hover:underline">{allOn ? "Clear all" : "Select all"}</button>}
            </div>
            {props.length === 0 ? <p className="text-xs text-slate-400">No properties in this region.</p> : (
              <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">
                {props.map((p) => (
                  <label key={p} className="flex items-center gap-2 text-sm text-slate-700">
                    <input type="checkbox" checked={propertyIds.includes(p)} onChange={() => toggle(p)} data-testid={`cmp-region-prop-${g.id}-${p}`} className="h-4 w-4 rounded border-slate-300 text-sky-600" />
                    <span className="truncate">{nameOf(p)}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
